import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initStorage } from "./utils/storage";

// Restore IndexedDB-backed data to memoryStore before React reads it in hooks
initStorage().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<React.StrictMode><App /></React.StrictMode>);
});
